import React from 'react';

import { PageProps, Link, graphql } from "gatsby"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import './index.scss'
import ShopifyLogo from "../../../components/images/shopify"
import ImageFooted from '../../../components/widgets/imageFooted';
import { IMG_Shopify } from '../../../components/images/docs/shopify';
import SectionNavigate from '../../../components/widgets/sectionNavigate';
import { TabEntry, Tabulator } from '../../../components/widgets/tabulator';

type DataProps = {
    site: {
        buildTime: string
    }
}

const ShopifyFacturacionCheckout: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <Layout isEcommerce={true} location={location}>
        <SEO title="FiscalPOP para eCommerce" />
        <div id='ShopifyDocs' className="_DOCS">
            <div className="integrationLogo">
                <ShopifyLogo />
            </div>
            <h2>
                Facturación desde tu POS
            </h2>
            <p>
                Compras realizadas desde tu POS, pueden ser facturadas desde la misma aplicación de Shopify.<br />
                <b>Para esto, es necesario que la app de FiscalPOP esté instalada en tu tienda y activar la configuración desde "Sales channels".</b>
            </p>
            <p>
                Una vez configurado, podrás facturar pedidos pendientes de factura o consultar si los pedidos ya fueron facturados.
            </p>
            <div className='_posImageNoted'>
                <ImageFooted explanation={`La forma de facturación en POS es nativa y se accede desde "Order Details" (Detalle de pedido).`}>
                    <IMG_Shopify file={'posBilling'} />
                </ImageFooted>
            </div>
            <h3>
                Pasos para activar facturación en POS
            </h3>
            <p>
                Desde tu Admin de Shopífy, ir a canales de venta y elegir "POS" (Point of Sale). y en el menú izquierdo extendido, dar click en "Settings".
            </p>

            <Tabulator>
                <TabEntry label="Paso 1" sublabel="Ir a Configuración de POS">
                    <ImageFooted
                        explanation={`1. Desde tu Admin de Shopífy, ir a canales de venta y elegir "POS" (Point of Sale). y en el menú izquierdo extendido, dar click en "Settings".\n En esta vista, verás "POS apps" en el primer bloque "General".`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'posBillingConfigure'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 2" sublabel="Agregar FiscalpOP a POS">
                    <ImageFooted
                        explanation={`2. Al dar click en "POS Apps", verás la lista de aplicaciones disponibles, encuentra la de FiscalPOP y da click en ella para agregarla. El nombre de la aplicación ṕara POS es "Facturar Pedido"`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'posBillingAppList'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 3" sublabel="Activar en POS">
                    <ImageFooted
                        explanation={`3. AAl haber dado click en la app de FiscalPOP anterior, verás el diálogo de customizar la app. Solamente dar click en "Add" para agregarla a tu POS.\nUna vez agregada, el mensaje cambiará "Not added" a verde y ya podrás facturar pedidos desde la vista de "Order Details".`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'posBillingAppAdd'} />
                    </ImageFooted>
                </TabEntry>
            </Tabulator>
            <p>
                Si necesitas orientación en configurarla, escríbenos a <a href="mailto:soporte@fiscalpop.com">soporte@fiscalpop.com</a>
            </p>
            <SectionNavigate previous={`/ecommerce/shopify/facturacion-en-order-status`} next={`/ecommerce/shopify/post-facturacion`} />
        </div>
    </Layout>
)

export default ShopifyFacturacionCheckout;